<template>
  <v-navigation-drawer
    v-if="$auth.check() && (!['Err404', 'NewExecution', 'ContinueExecution', 'ReviewExecution', 'ExecuteTask', 'ContinueTask' ].includes($route.name) && $route.name)"
    v-model="drawer"
    id="app-drawer"
    app
    floating
    persistent
    mobile-breakpoint="991"
    width="260"
    :color="$vuetify.theme.isDark ? '' : 'quarternary'"
  >
    <v-list nav :class="[active_solution_settings && !active_solution_settings.use_white_label? 'mb-10 pb-10' : '']">
      <!-- Bug in Vuetify for first child of v-list not receiving proper border-radius -->
      <div />

      <v-list-item style="cursor: pointer">
        <v-list-item-content>
          <div class="d-flex justify-center">
            <v-img @click="$router.push('/')" :src="logo" contain :max-height="80" :max-width="170" class="adaptive-logo" />
          </div>
        </v-list-item-content>
      </v-list-item>

      <!-- <v-divider class="mx-4 my-2" /> -->
      <v-list-item
        v-for="(link, i) in listLinks.filter((o) =>
          $can(o.permission.act, o.permission.on)
        )"
        :key="i"
        :to="link.to"
        active-class="primary darken-1  white--text"
      >
        <v-list-item-action>
          <v-icon>{{ link.icon }}</v-icon>
        </v-list-item-action>

        <v-list-item-title v-text="link.text" />
      </v-list-item>
    </v-list>
    <v-footer class="pb-0 mt-0"
        style="background: inherit"
    >
      <span class="grey--text text--lighten-1 caption"> v. 2.3.{{ $moment(app_version).format('x') }}</span>
    </v-footer>
    <template v-if="(solution_is_resolve || company_has_logo) && !active_solution_settings.use_white_label">
      <div class="mx-5"></div>
      <v-footer absolute class="pb-3 mt-5"
        style="background: inherit"
      >
        <!-- <v-img @click="$router.push('/')" :src="logo" contain height="32" /> -->
        <template v-if="company_has_logo">
          <v-img
            :src="getCompanyLogo"
            style="cursor: pointer"
            contain
            height="35"
          />
        </template>
        <template v-if="!company_has_logo">
          <span class="caption">Parceiro:</span>
          <v-img
            @click="redirectToResolve()"
            :src="resolve"
            style="cursor: pointer"
            contain
            height="35"
          />
        </template>

        </v-footer>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapMutations, mapState, mapGetters } from "vuex";
import links from "@/mixins/links";
import responsive from "@/mixins/responsive";
// import logo from "@/assets/logo_checkbits.png";
import resolve from "@/assets/logo_resolve_h.png";
import acitve_company from "@/mixins/active_company";

export default {
  data() {
    return {
      // logo,
      logo: '',
      resolve,
    };
  },
  mixins: [links, responsive, acitve_company],
  methods: {
    setLogo() {
      const is_dark_mode = localStorage.getItem("is_dark_mode");
      // console.log("is_dark_mode", is_dark_mode);
      if (is_dark_mode == 'true') {
        this.logo =  process.env.VUE_APP_API_ROOT + `/company_settings/logo_dark`;
      } else {
        this.logo =  process.env.VUE_APP_API_ROOT + `/company_settings/logo`;
      }
      // console.log({logo: this.logo})
    },
    redirectToResolve() {
      window.open(
        "https://resolvesolucoescriativas.negocio.site/?utm_source=gmb&utm_medium=referral",
        "_blank"
      );
    },
    ...mapMutations({
      setDrawer: "App/setDrawer",
    }),
  },
  updated () {
    this.setLogo();
  },
  computed: {
    app_version(){
      return document.documentElement.dataset.buildTimestampUtc
    },
    listLinks() {
      let side = [...this.sideLinks]
      if (this.use_flows){
        let flow_obj = {
          to: "/flows",
          icon: "mdi-check-network-outline",
          text: this.active_solution_settings.flow_config.flow_name || "Fluxos",
          permission: { act: "read", on: "Flow" },
        }
        side.splice(0, 0, flow_obj)
      }
      if (
        this.can_use_ai_on_done_form_to_report() && 
        this.$can('create', 'AiAnalysis') // tem que analisar se remove
      ){
        let ai_analysis = {
          to: "/ai_analysis",
          icon: "mdi-creation-outline",
          text: "Análises com IA",
          permission: { act: "read", on: "DoneForm" },
        }
        side.splice(0, 0, ai_analysis)
      }
      if (this.use_custom_fields){
        let custom_field_obj = {
          to: "/custom_fields",
          icon: "mdi-database-edit",
          text: "Listas Personalizadas",
          permission: { act: "create", on: "CustomField" },
        }
        side.splice(2, 0, custom_field_obj)
      }
      if (this.allow_extra_info){
        let extra_info_obj = {
          to: "/extra_infos",
          icon: "mdi-book-information-variant",
          text: "Informações extras",
          permission: { act: "create", on: "Form" },
        }
        side.splice(3, 0, extra_info_obj)
      }
      if (this.allow_imports){
        let import_obj = {
          to: "/data_import",
          icon: "mdi-file-upload",
          text: "Importações",
          permission: { act: "create", on: "Form" },
        }
        side.splice(7, 0, import_obj)
      }
      if (this.allow_laudo_doalto){
        let laudo_obj = {
          to: "/laudos",
          icon: "mdi-file-cog",
          text: "Gerar Laudo",
          permission: { act: "create", on: "Form" },
        }
        side.splice(5, 0, laudo_obj)
      }
      if (this.allow_approvals) {
        let approval_obj = {
          to: "/approvals",
          icon: "mdi-check-decagram",
          text: "Aprovações",
          permission: { act: "read", on: "Approval" }
        }
        side.splice(3, 0, approval_obj)
      }
      if (this.allow_approvals && ['only_execute', 'only_execute_tasks'].includes(this.profile.roles[0].name)) {
        this.mobileLinks[1].permission.act = "create"
        // console.log("miau > ", side)
        // let done_form_obj = {
        //   to: "/done_forms",
        //   icon: "mdi-file-document-box-check",
        //   text: "Enviados",
        //   permission: { act: "create", on: "DoneForm" },
        // };
        // side.splice(0, 0, done_form_obj);
      }
      if (
        ["super admin", 'SDR'].includes(this.profile.role_name_pt) || 
        (
          ["Administrar"].includes(this.profile.role_name_pt) 
          &&            
          (['checkbits_admin@ckb.com', 'heythor_1786_admin@ckb.com', 'ckba@ckb.com'].includes(this.profile.email))
        )
      ) {
        let clients_usage_obj = {
          to: "/clients_list",
          icon: "mdi-account-group-outline",
          text: "Clientes",
          permission: { act: "read", on: "Company" },
        }
        side.splice(5, 0, clients_usage_obj)
      }
      // console.log('can', this.can_use_ai(), this.$can('read', 'AiExtract'))
      
      if (this.can_use_ai() && this.$can('read', 'AiExtract')){
        side.push({
          to: "/ai_extract",
          icon: "mdi-information",
          text: "Extrato AI",
          permission: { act: "read", on: "AiExtract" },
        })
      }
      if (this.isMobile) {
        return [...side, ...this.lastLinks];
      } else {
        return [...this.mobileLinks, ...side, ...this.lastLinks];
      }
    },
    drawer: {
      get() {
        return this.$store.getters["App/getDrawer"];
      },
      set(val) {
        this.setDrawer(val);
      },
    },
    active_solution() {
      if (this.solutionID && this.allSolutions) {
        return this.allSolutions.find((o) => o.id == Number(this.solutionID));
      }
    },
    solution_is_resolve() {
      if (this.active_solution) {
        return ["resolve", "corona"].includes(
          this.active_solution.proposal_name.toLowerCase()
        );
      }
    },
    company_has_logo() {
      if (this.active_solution) {
        if (this.getCompanyLogo) {
          return true
        }
      }
      return false
    },
    active_solution_settings() {
      if (this.active_solution) {
        return this.active_solution.settings
      }
    },
    use_custom_fields() {
      if (this.active_solution && this.active_solution_settings) {
        return this.active_solution_settings.item_kinds.findIndex(ik => ik.kind == 'custom_field') > -1
      }
    },
    use_flows() {
      if (this.active_solution && this.active_solution_settings) {
        return this.active_solution_settings.allow_flow
      }
    },
    allow_extra_info() {
      if (this.active_solution && this.active_solution_settings) {
        return this.active_solution_settings.allow_extra_info
      }
    },
    allow_imports() {
      if (this.active_solution && this.active_solution_settings) {
        const {
          allow_basic_import_custom_values,
          allow_basic_import_forms,
          allow_import_massive_form_duplcation,
          allow_import_massive_schedule_creation
        } = this.active_solution_settings

        return allow_basic_import_custom_values || allow_basic_import_forms || allow_import_massive_form_duplcation || allow_import_massive_schedule_creation
      }
    },
    allow_laudo_doalto() {
      if (this.active_solution && this.active_solution_settings) {
        return this.active_solution_settings.allow_laudo_doalto
      }
    },
    allow_approvals() {
      if (this.active_solution && this.active_solution_settings) {
        // return this.active_solution_settings.allow_approvals;
        return this.active_solution_settings.allow_done_form_approvals;
      }
    },
    ...mapState({
      profile: (state) => state.User.oneUser,
      solutionID: (state) => state.Solution.solutionID,
      allSolutions: (state) => state.Solution.allSolutions,
      // data: state=> state.Module.state_var
    }),
    ...mapGetters({
      getCompanyLogo: 'User/getUserCompanyLogo',
    })

  },
};
</script>

<style scoped>
</style>
